/* SJ rows: karuzela + strzalki dla KAZDEJ sekcji Products:rows na home (takze nowo dodanych) */
(function(){
  function init(){
    if(!document.body.classList.contains('template-index')) return;
    document.querySelectorAll('.shopify-section').forEach(function(sec){
      if(sec.dataset.sjArrows || sec.classList.contains('shopify-section-group-overlay-group')) return;
      var scroller=sec.querySelector('.grid-products');
      var header=sec.querySelector('.section-header');
      if(!scroller || !header) return;
      sec.dataset.sjArrows='1';
      var wrap=document.createElement('div');
      wrap.className='sj-row-arrows';
      wrap.innerHTML='<button type="button" class="sj-ar sj-ar-prev" aria-label="Poprzednie">&#8249;</button><button type="button" class="sj-ar sj-ar-next" aria-label="Następne">&#8250;</button>';
      header.appendChild(wrap);
      wrap.querySelector('.sj-ar-prev').addEventListener('click',function(){scroller.scrollBy({left:-scroller.clientWidth*0.8,behavior:'smooth'})});
      wrap.querySelector('.sj-ar-next').addEventListener('click',function(){scroller.scrollBy({left:scroller.clientWidth*0.8,behavior:'smooth'})});
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
  setTimeout(init,1500);
})();

(function(){
  function moveKatArrows(){
    var sec=document.querySelector("[id*='__collection_list_gradient_overlay_nKTawQ']");
    if(!sec || sec.dataset.sjKat) return;
    var header=sec.querySelector('.section-header');
    var arrows=sec.querySelectorAll('.swiper-arrows');
    if(!header || arrows.length<2) return;
    sec.dataset.sjKat='1';
    var pill=sec.querySelector('.sj-viewall');
    if(pill){ header.appendChild(pill); var slider=sec.querySelector('slide-section')||sec.querySelector('.collection-grid'); if(slider && !sec.querySelector('.sj-viewall-mob')){ var m=pill.cloneNode(true); m.classList.add('sj-viewall-mob'); slider.parentNode.insertBefore(m, slider.nextSibling); } }
    var wrap=document.createElement('div');
    wrap.className='sj-kat-arrows';
    header.appendChild(wrap);
    arrows.forEach(function(a){wrap.appendChild(a);});
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',moveKatArrows); else moveKatArrows();
  document.addEventListener('shopify:section:load',moveKatArrows);
  setTimeout(moveKatArrows,1500);
})();
